import { ScrollableTabsBase } from "./app.tabs-base.js";

var image_grid_tabs_default = (() => {
    if (customElements.get("image-grid-tabs")) return;
    customElements.define("image-grid-tabs", class ImageGridTabs extends ScrollableTabsBase {
        sectionSelector=".section--image-grid";
        onTabActivated(tab) {
            this.updateShopAll(tab, "[data-ig-shop-all]");
        }
    });
})();